import React from "react"
import Header from "./Header"

const VirtualCube = () => {
    return (
        <Header title="Haha">
            <p className="lead">Nothing to see here. Move along.</p>
        </Header>
    )
}

export default VirtualCube
